<template>
    <div>
        <Panel module="RFID" title="Vincular Tags" layout="large" :showFilter="false" :showSearch="false"
            :showButtons="false">
            <div slot="content-main">
                <br>
                <ProductRfidLinker />
            </div>
        </Panel>

    </div>
</template>

<script>

import Panel from "@nixweb/nixloc-ui/src/component/layout/Panel";
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";

import ProductRfidLinker from '../../../components/modules/rfid/linker-rfid/ProductRfidLinker.vue'

import { mapMutations, mapGetters } from "vuex";

export default {
    name: "LinkProductTagsView",
    components: { Panel, Loading, Button, Modal, ProductRfidLinker },
    mounted() {
        this.removeLoading(["panel"]);
    },
    computed: {
        ...mapGetters("generic", ["showModal", "event"]),
    },
    methods: {
        ...mapMutations("generic", ["addEvent", "openModal", "removeLoading"]),
    },
}
</script>
<style scoped></style>